const componentContainer =
  "flex p-4 w-full items-center justify-between gap-2.5 self-stretch bg-north-sea rounded-t-lg border-solid border-b border-b-foggy-firth";
const nameContainer = "flex flex-1";
const nameStyles = "text-neutral-white font-semibold text-body-l leading-none md:leading-none";
const logoStyles = "h-[21px]";

export const PropertyPalHeader: React.FC = () => {
  return (
    <div className={componentContainer}>
      <div className={nameContainer}>
        <div className={nameStyles}>Edi - Your Property Pal</div>
      </div>
      <div>
        <img className={logoStyles} src="/static/logos/espc-logo.svg" alt="ESPC Logo" />
      </div>
    </div>
  );
};
